
<div class="px-6 py-16 md:px-12 lg:px-16">
    <ng-content></ng-content>
</div>
